module.exports = __webpack_public_path__ + "img/logo.d48fec0f.png";